/**
 * Detects Instagram / Facebook Messenger Send API structured templates
 * (template_type + elements/buttons). WhatsApp Cloud API templates use `components` instead.
 */
export function isMetaMessengerTemplatePayload(body) {
  if (body == null) return false;
  const raw = typeof body === "string" ? body.trim() : "";
  if (!raw || !raw.startsWith("{")) return false;
  try {
    const t = JSON.parse(raw);
    return !!(t && typeof t === "object" && t.template_type && !t.components);
  } catch {
    return false;
  }
}
